import { SELECT_JOBCOINS_PACKET, LOAD_JOBCOINS_PACKETS, CLEAN_SELECTED_JOBCOINS_PACKET } from "../actions/actionTypes";

const initialState = {
    packets: [],
    selectedPacket: null
};

export const jobcoinsPacketReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_JOBCOINS_PACKETS:
            return {
                ...state,
                packets: action.packets
            };
        case SELECT_JOBCOINS_PACKET:
            return {
                ...state,
                selectedPacket: action.packet
            };
        case CLEAN_SELECTED_JOBCOINS_PACKET:
            return {
                ...state,
                selectedPacket: null
            };
        default:
            return state;
    }
};